<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal" :id="id" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">
    <t-input v-model="form.name"  :add-error="error.name" label="Tipo de Matéria-Prima" submitted focus required/>
  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";

export default {
  name: "TypeRawMaterialDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-type-raw-material",
      title: "Cadastro rápido de Tipo de Matéria-Prima",
      okText: "Incluir Tipo de Matéria-Prima",
      form: {
        typeRawMaterialId: 0,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    showModal() {

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora

    },

    async onSubmit() {

      //Validações específicas da tela

      await this.setInsertDialog("product/type-raw-material", (item) => {

        this.itemInserted.value = item.typeRawMaterialId
        this.itemInserted.text = this.form.name

        this.successInsert()

      })

    }
  },
  watch:{
    noOptionAdd(){
      this.form.name = this.noOptionAdd
    }
  }
}
</script>
